import { useState } from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';
import { FaShoppingCart } from 'react-icons/fa';
import { useCart } from './context/CartContext';
import CartDrawer from './components/CartDrawer';
import logo from './ratnavastra_logo.png';
import './App.css';

import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Products from './components/Products';
import Features from './components/Features';

function AppContent() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);
  const [cartOpen, setCartOpen] = useState(false);
  const { count } = useCart();
  return (
    <div className="App">
      <header className="App-header">
        
        <button
          className={`menu-toggle ${menuOpen ? 'is-open' : ''}`}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(v => !v)}
        >
          <span></span><span></span><span></span>
        </button>

        <div className="logo-section">
          <img src={logo} className="App-logo" alt="logo" />
        </div>

        <nav className={`App-nav ${menuOpen ? 'open' : ''}`}>
          <ul onClick={closeMenu}>
            <li><NavLink to="/" end>Home</NavLink></li>
            <li><NavLink to="/products">Products</NavLink></li>
            <li><NavLink to="/features">Features</NavLink></li>
            <li><NavLink to="/about">About</NavLink></li>
            <li><NavLink to="/contact">Contact</NavLink></li>
          </ul>
        </nav>
        <button className="cart-button" onClick={() => setCartOpen(true)} aria-label="Open cart">
  <FaShoppingCart />
  {count > 0 && <span className="cart-badge">{count}</span>}
</button>
      </header>
<CartDrawer open={cartOpen} onClose={() => setCartOpen(false)} />
      <main className="App-body">
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            {/* 404 */}
            <Route path="*" element={<div className="section"><h2>Page not found</h2></div>} />
          </Routes>
      </main>

      <Footer />
    </div>
  );
}

export default AppContent;
